import { render, staticRenderFns } from "./InsuredFormLife.vue?vue&type=template&id=33d8c6b8&scoped=true&"
import script from "./InsuredFormLife.vue?vue&type=script&lang=ts&"
export * from "./InsuredFormLife.vue?vue&type=script&lang=ts&"
import style0 from "./InsuredFormLife.vue?vue&type=style&index=0&id=33d8c6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d8c6b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
